import { createSlice } from "@reduxjs/toolkit";
import chatService from "./../../../services/chatService/chatService";

const chatSlice = createSlice({
    name: "chat",
    initialState: {
        user: null,
        admins: [],
        onlineUsers: [],
        messages: [],
        typingInfo: null,
        pairedAdmin: null,
    },

    reducers: {

        setUser(state, action) {
            state.user = action.payload;
        },

        addMessage(state, action) {
            state.messages.push(action.payload);
        },

        setTyping(state, action) {
            state.typingInfo = action.payload;
        },

        stopTyping(state) {
            state.typingInfo = null;
        },

        setOnlineUsers(state, action) {
            state.onlineUsers = action.payload;
        },

        setPairedAdmin(state, action) {
            state.pairedAdmin = action.payload;
        }
    }
});

export const {
    setUser,
    addMessage,
    setTyping,
    stopTyping,
    setOnlineUsers,
    setPairedAdmin
} = chatSlice.actions;

export default chatSlice.reducer;

// -------------------
//  SOCKET LISTENERS
// -------------------
export function initializeChatListeners(dispatch) {
    chatService.listen("message", (data) => {
        dispatch(addMessage(data));
    });

    chatService.listen("typing", (data) => {
        dispatch(setTyping(data));
    });

    chatService.listen("stopTyping", () => {
        dispatch(stopTyping());
    });

    chatService.listen("onlineUsers", (users) => {
        dispatch(setOnlineUsers(users));
    });

    chatService.listen("paired", (adminId) => {
        dispatch(setPairedAdmin(adminId));
    });
}
